import {Injectable} from '@angular/core';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:GeneratorsService'));

@Injectable()
export class GeneratorsService {

    public state = {
        generatorCfg: {
            selectedGenerator: null,
            showerDimensionsExceeded: false,
            lengthFtIsValid: false,
            widthFtIsValid: false,
            heightFtIsValid: false,
            materialIsValid: false,
        },
        roomDimensions: {
            lengthFt: null,
            lengthIn: null,
            widthFt: null,
            widthIn: null,
            heightFt: null,
            heightIn: null,
            wallType: null,
            cubicFeet: null,
            cubicFeetAdjusted: null
        }
    };
    
    constructor () {
        // 'Construct generators service' );
    }

    
    public resetCalculatorInputs() {
        // 'Reset calculator inputs' );

        this.state.roomDimensions.lengthFt = null;
        this.state.roomDimensions.widthFt = null;
        this.state.roomDimensions.heightFt = null;
        this.state.roomDimensions.lengthIn = null;
        this.state.roomDimensions.widthIn = null;
        this.state.roomDimensions.heightIn = null;
        this.state.roomDimensions.wallType = 'stone';
        this.state.roomDimensions.cubicFeet = null;
        this.state.roomDimensions.cubicFeetAdjusted = null;
        this.state.generatorCfg.selectedGenerator = null;

    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/generators-service.ts